import { Component } from "react"

/* Constants */
import { sound, utils } from "../constants"

/* Components */
import { SVG, Chip, Card } from "../components"

/* Components */
import { CHOICE } from "../constants/status"

/* Rates */
class Rates extends Component {

    /* Get Color */
    getColor = value => {

        /* Fields */
        const { chips } = this.props

        /* Default Color */
        let color = chips[0].color

        /* Start cycle */
        chips.forEach(item => {
            if (item.value <= value) {
                color = item.color
            }
        })

        return color
    }

    /* Notify */
    notify = type => {

        /* Fields */
        const { notify } = this.props

        /* Show */
        notify(type, "show")

        /* Close */
        const timer = setTimeout(() => {
            notify(type, "close")
            clearTimeout(timer)
        }, 2000)
    }

    /* Add Action */
    add = target => {

        /* Fields */
        const { status, stake, selected, chips, setStake, list, setList, balance, max } = this.props
        const _stake = { ...stake }
        const _list = [...list]

        /* Bonus */
        const bonusMax = parseFloat(max) / 10
        const perfectPairMax = parseFloat(max) / 100 * 3

        /* Check */
        if (status === CHOICE && chips[selected] && target) {

            /* Determine Value */
            const value = chips[selected].value

            /* Player or Banker Case */
            if (target === "player" || target === "banker") {

                /* Determine Other Target */
                const other = target === "player" ? _stake.banker : _stake.player

                /* Check other */
                if (!other) {
                    _stake[target] = _stake[target] + value
                }
                else {
                    sound.play("blocked", 0.3)
                    return
                }

            }
            else {

                /* Add Value */
                _stake[target] = _stake[target] + value

            }

            /* Balance Error */
            if (value > parseFloat(balance)) {
                this.notify("balanceError")
                sound.play("blocked", 0.3)
                return
            }

            /* Player | Banker MAX */
            if (_stake.player > parseFloat(max) || _stake.banker > parseFloat(max)) {
                this.notify("maxBetError")
                sound.play("blocked", 0.3)
                return
            }

            /* Tie | Player Pair | Banker | Either MAX */
            if (_stake.tie > parseFloat(bonusMax) || _stake.playerPair > parseFloat(bonusMax) || _stake.bankerPair > parseFloat(bonusMax) || _stake.eitherPair > parseFloat(bonusMax)) {
                this.notify("maxBetError")
                sound.play("blocked", 0.3)
                return
            }

            /* Perfect Pait MAX */
            if (_stake.perfectPair > parseFloat(perfectPairMax)) {
                this.notify("maxBetError")
                sound.play("blocked", 0.3)
                return
            }

            /* Add Target to List */
            _list.push({ value, type: "add", target })

            /* Set Stake & List */
            setStake(_stake)
            setList(_list)

            sound.play("sound", 0.2)
        }
    }


    /* Draw Chip */
    _chip = (type, place = "") => {

        /* Fields */
        const { stake, result } = this.props

        /* Determine Values */
        const value = stake[type] ? stake[type] : 0
        const color = this.getColor(value)
        const size = place === "bonus" ? 45 : 60

        /* Check Value */
        if (value) {

            /* Determine Fold */
            let isFold = ""

            /* Check Result */
            if (result && !result[type]) {
                isFold = "fold"
            }

            return (
                <div className={`rates-bonus-bet-inner ${isFold} ${place}`}>
                    <Chip value={`${value}`} size={size} color={color} />
                </div>
            )
        }
    }

    /* Draw Win Chips */
    _win = (type, place = "") => {

        /* Fields */
        const { stake, result } = this.props

        /* Check Result */
        if (parseFloat(stake[type]) > 0 && result && result[type] && parseFloat(result[type].multiplier) > 0) {

            /* Determine Values */
            const bet = stake[type] ? stake[type] : 0
            const value = bet * parseFloat(result[type].multiplier)
            const multiplier = `${result[type].multiplier}x`
            const color = this.getColor(value)
            const size = place === "bonus" ? 45 : 60

            return (
                <div className={`rates-win-chip ${place}`}>
                    <Chip value={value} size={size} color={color} />
                    <div className="rates-win-chip-text">{multiplier}</div>
                </div>
            )

        }
    }

    /* Draw Animation */
    _animation = (type, place = "") => {

        /* Fields */
        const { list } = this.props
        const size = place === "bonus" ? 45 : 60

        return (
            <div className={`rates-animated-chips ${place}`}>
                {list.map((chip, index) => {

                    /* Determine Color */
                    const color = this.getColor(chip.value)

                    /* Check Target */
                    if (chip.target === type) {
                        return (
                            <div className={`rates-animated-chip ${chip.type === "add" ? "visible" : "hidden"}`} key={`${index}`}>
                                <Chip size={size} color={color} value={chip.value} />
                            </div>
                        )
                    }

                    return null
                })}
            </div>
        )
    }


    /* Draw Cards */
    _cards = (type, cards) => {

        /* Check Cards */
        if (type && cards && Array.isArray(cards) && cards.length > 0) {

            const _cards = utils.getUniqueCards(cards)

            return (
                <div className={`rate-cards ${type}`}>
                    {_cards.map((card, index) =>
                        <div className="rate-card" key={`${index}`}>
                            <Card data={card.name} />
                        </div>
                    )}
                </div>
            )
        }
    }


    /* Draw Spaces */
    _spaces = type => (
        <div className={`rate-card-spaces ${type}`} >
            <div className="rate-card-space">
                <SVG type="card-space" />
            </div>
            <div className="rate-card-space">
                <SVG type="card-space" />
            </div>
        </div>
    )

    /* Draw Bonus Left */
    _left = () => {
        return (
            <div className="rates-bonus-container left">

                {/* Player Pair */}
                <div onClick={() => this.add("playerPair")} className="rates-bonus rates-player-pair">
                    <div className="rates-bonus-title">PLAYER PAIR <span>11:1</span></div>
                    <div className="rates-bonus-bet">
                        <SVG type="chip-space" />
                        {this._chip("playerPair", "bonus")}
                        {this._win("playerPair", "bonus")}
                        {this._animation("playerPair", "bonus")}
                    </div>
                </div>

                {/* Perfect Pair */}
                <div onClick={() => this.add("perfectPair")} className="rates-bonus rates-perfect-pair">
                    <div className="rates-bonus-title">PERFECT PAIR <span>25:1</span></div>
                    <div className="rates-bonus-bet">
                        <SVG type="chip-space" />
                        {this._chip("perfectPair", "bonus")}
                        {this._win("perfectPair", "bonus")}
                        {this._animation("perfectPair", "bonus")}
                    </div>
                </div>

            </div>
        )
    }


    /* Draw Bonus Right */
    _right = () => {
        return (
            <div className="rates-bonus-container right">

                {/* Banker Pair */}
                <div onClick={() => this.add("bankerPair")} className="rates-bonus rates-banker-pair">
                    <div className="rates-bonus-title">BANKER PAIR <span>11:1</span></div>
                    <div className="rates-bonus-bet">
                        <SVG type="chip-space" />
                        {this._chip("bankerPair", "bonus")}
                        {this._win("bankerPair", "bonus")}
                        {this._animation("bankerPair", "bonus")}
                    </div>
                </div>

                {/* Either Pair */}
                <div onClick={() => this.add("eitherPair")} className="rates-bonus rates-either-pair">
                    <div className="rates-bonus-title">EITHER PAIR <span>5:1</span></div>
                    <div className="rates-bonus-bet">
                        <SVG type="chip-space" />
                        {this._chip("eitherPair", "bonus")}
                        {this._win("eitherPair", "bonus")}
                        {this._animation("eitherPair", "bonus")}
                    </div>
                </div>

            </div>
        )
    }


    /* Draw Player */
    _player = () => {

        /* Fields */
        const { status, stake, playerCards, playerScore } = this.props

        /* Determine Disabled Style */
        const disabled = status === CHOICE && parseFloat(stake.banker) > 0 ? "disabled" : "default"

        return (
            <div onClick={() => this.add("player")} className={`rates-player ${disabled} ${this.winStyle("player")}`}>

                <SVG type="player" />

                <div className="player-top">
                    <div className="rates-title">PLAYER</div>
                    <div className="rates-value">1:1</div>
                </div>

                <div className="rates-player-score">{playerScore}</div>

                <div className="rates-bet">
                    <SVG type="chip-space" />
                    {this._chip("player")}
                    {this._win("player")}
                    {this._animation("player")}
                </div>

                {/* Draw Cards */}
                {this._cards("player", playerCards)}

                {/* Draw Card Spaces */}
                {this._spaces("player")}

            </div>
        )
    }


    /* Draw Tie */
    _tie = () => {
        return (
            <div onClick={() => this.add("tie")} className={`rates-tie ${this.winStyle("tie")}`}>
                <div className="rates-title">TIE</div>
                <div className="rates-value">8:1</div>
                <div className="rates-bet">
                    <SVG type="chip-space" />
                    {this._chip("tie")}
                    {this._win("tie")}
                    {this._animation("tie")}
                </div>
            </div>
        )
    }


    /* Draw Banker */
    _banker = () => {

        /* Fields */
        const { status, stake, bankerCards, bankerScore } = this.props

        /* Determine Disabled Style */
        const disabled = status === CHOICE && parseFloat(stake.player) > 0 ? "disabled" : "default"


        return (
            <div onClick={() => this.add("banker")} className={`rates-banker ${disabled} ${this.winStyle("banker")}`}>

                {/* Draw SVG Place */}
                <SVG type="banker" />

                {/* Draw Head */}
                <div className="banker-top">
                    <div className="rates-value">0.95:1</div>
                    <div className="rates-title">BANKER</div>
                </div>

                <div className="rates-banker-score">{bankerScore}</div>

                {/* Draw Bet */}
                <div className="rates-bet">
                    <SVG type="chip-space" />
                    {this._chip("banker")}
                    {this._win("banker")}
                    {this._animation("banker")}
                </div>

                {/* Draw Cards */}
                {this._cards("banker", bankerCards)}

                {/* Draw Card Spaces */}
                {this._spaces("banker")}

            </div>
        )
    }


    /* Win Style */
    winStyle = (type = "") => {

        /* Fields */
        const { result } = this.props

        /* Check Result */
        if (result && result.win) {
            if (result.win === type) {
                return "rates-win"
            }
            else {
                return "rates-lose"
            }
        }

        return ""
    }


    render = () => {

        /* Fields */
        const { status } = this.props

        return (
            <div className="rates-container">
                <div className={`rates rates-${status}`}>

                    {/* Draw Left Rates */}
                    {this._left()}

                    <div className="rates-center">

                        {/* Draw Player */}
                        {this._player()}

                        {/* Draw Tie */}
                        {this._tie()}

                        {/* Draw Banker */}
                        {this._banker()}

                    </div>

                    {/* Draw Left Rates */}
                    {this._right()}

                </div>
            </div>
        )
    }
}

export default Rates